export const getOrganizationMutationKey = () => [`planner_organization`];

export const getOrganizationResourcesMutationKey = () => [`planner_organization_resources`];

export const getOrganizationUsersMutationKey = () => [`planner_organization_users`];

export const getOrganizationAvatarMutationKey = () => [`planner_organization_avatar`];
